import angular from "angular"

const templateUrl = require("ngtemplate-loader!html-loader!./ayuda.component.html")

AyudaController.$inject = ["store"]
function AyudaController(store) {
  var self = this

  self.institution_code = store.get("user").institution_code || ""

  self.links = defineLinksByInstitution(self.institution_code)
}

function defineLinksByInstitution(institutionCode) {
  switch (institutionCode) {
    case "igs.cl":
      return [
        {
          href: "../../static/pdfs/igs/p172_igs.pdf",
          download: "P172_Orientación_Psicológica_Estudiantes_IGS.pdf",
          title: "Orientación Psicológica"
        },
        {
          href: "../../static/pdfs/igs/p176_igs.pdf",
          download: "P176_Acompañamiento_Académico_Estudiantes_IGS.pdf",
          title: "Acompañamiento Académico"
        },
        {
          href: "../../static/pdfs/igs/p178_igs.pdf",
          download: "P178_Vida_Estudiantil_IGS.pdf",
          title: "Vida Estudiantil"
        },
        {
          href: "../../static/pdfs/igs/manual_satd.pdf",
          download: "Manual_Plataforma_SATD_IGS.pdf",
          title: "Manual plataforma SATD"
        }
      ]
    case "upv.cl":
      return [
        {
          href: "../../static/pdfs/upv/manual_satd_upv.pdf",
          download: "Manual_de_Uso_UPV.pdf",
          title: "Manual de Uso"
        }
      ]
    case "ulandivar.gt":
      return [
        {
          href:
            "../../static/pdfs/ulandivar/manual_para_el_uso_de_la_plataforma_stella__segunda_edicion_actualizada__agosto_2024.pdf",
          download: "Manual_de_uso_del_sistema_de_seguimiento_académico.pdf",
          title: "Manual de uso del sistema de seguimiento académico"
        }
      ]
    default:
      return []
  }
}

angular.module("appModule").component("ayuda", {
  templateUrl: templateUrl,
  controller: AyudaController
})
